<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    :close-on-content-click="false"
    max-width="300"
  >
    <template v-slot:activator="{ on }">
      <div
        class="d-flex align-center"
        style="cursor: pointer; overflow: hidden; max-width: 100%;"
        title="Switch study dataset"
        v-on="on"
      >
        <span
          class="font-weight-bold text-truncate"
          :class="dark ? 'white--text' : 'subtitle-2 primary--text'"
        >
          {{
            activeCollection ? activeCollection.label : 'Select Shared Dataset'
          }}
        </span>
        <v-icon
          small
          :color="dark ? 'white' : 'primary'"
          class="ml-1"
          style="flex-shrink: 0;"
          >mdi-chevron-down</v-icon
        >
      </div>
    </template>
    <v-card>
      <v-card-text class="pa-2">
        <v-autocomplete
          v-model="picked"
          :items="items"
          item-text="label"
          item-value="id"
          return-object
          dense
          outlined
          hide-details
          autofocus
          placeholder="Select dataset…"
          @change="onPick"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                :class="item.clearOption ? 'grey--text font-italic' : ''"
              >
                {{ item.clearOption ? 'No dataset selected' : item.label }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'CollectionSwitcherMenu',
  props: {
    activeCollection: { type: Object, default: null },
    availableCollections: { type: Array, default: () => [] },
    dark: { type: Boolean, default: false },
  },
  data() {
    return {
      menuOpen: false,
      picked: null,
    };
  },
  computed: {
    // Prepend a blank "clear" option so a selected dataset can be
    // deselected (returning the panel to its welcome/empty state). Only
    // shown when a dataset is currently active.
    items() {
      if (!this.activeCollection) return this.availableCollections;
      return [
        { id: '__clear__', label: '', clearOption: true },
        ...this.availableCollections,
      ];
    },
  },
  methods: {
    onPick(col) {
      if (!col) return;
      this.menuOpen = false;
      this.picked = null;
      if (col.clearOption) {
        this.$emit('clear');
        return;
      }
      this.$emit('pick', col);
    },
  },
};
</script>
